





import Vue from 'vue';
import { Icon } from '../basic';
import copy from 'copy-to-clipboard';
import { Button } from './buttons';

export default Vue.extend({
  name: 'ClipboardButton',
  components: {
    Icon,
    Button,
  },
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      copied: false,
      timeout: undefined as number | undefined,
    };
  },
  methods: {
    copyToClipboard(): void {
      copy(this.value);
      this.copied = true;
      (this.$el as HTMLElement).blur();
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.copied = false;
      }, 5000);
    },
  },
});
